
import Http from "@core/fetch";
import { useData } from "@hooks/useData";
import { API__ChainNews } from "@models/api/ChainNews";
import { ChainNews, iChainNews } from "@models/ChainNews";
import { ID } from "@models";

async function getChainNews(chainId: ID): Promise<iChainNews[]> {
    const response: API__ChainNews[] = await Http.get('get chain news', { chainId });
    return response.map(n => new ChainNews(n));
}

export default function useChainNews(chainId: ID) {
    return useData([], getChainNews, chainId);
}